import React, { useMemo, useState, useEffect } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import Navbar from '../components/Navbar';
import { useSearch } from '../context/SearchContext';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import api from '../sever/Api';
import { useAuth } from '../context/AuthContext';
import updated from '../assets/updated.png';
import free from '../assets/free.png';
import Standard from '../assets/Standard.png';
import Premium from '../assets/Premium.png';
import premiumCrown from '../assets/Group 1000002094.png';
import closer from '../assets/closer.png';

const sampleQuestions = [
  {
    question: 'You\'re planning a group trip. What\'s your role?',
    options: [
      'I organize everything and make sure everyone is on track.',
      'I suggest fun ideas and keep the mood light.',
      'I help solve problems and keep things running smoothly.',
      'I go with the flow and support others\' plans.'
    ]
  }
];

const PersonalityTest = () => {
  const [selected, setSelected] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [showUpgradePopup, setShowUpgradePopup] = useState(false);
  const [isVerifying, setIsVerifying] = useState(false);
  const [syncTick, setSyncTick] = useState(0);
  const { updateUser } = useAuth();
  // Sync user from server to keep testsTaken accurate (esp. for Standard users)
  const syncUserFromServer = async () => {
    try {
      const response = await api.get('/api/billing/verify-payment');
      const { role, plan, maxTests, testsTaken } = response.data || {};
      const userStr = localStorage.getItem('user');
      if (userStr && (role || plan || maxTests !== undefined || testsTaken !== undefined)) {
        const user = JSON.parse(userStr);
        if (role) user.role = role;
        if (plan) user.plan = plan;
        if (maxTests !== undefined) user.maxTests = maxTests;
        if (testsTaken !== undefined) user.testsTaken = testsTaken;
        localStorage.setItem('user', JSON.stringify(user));
        try { updateUser(user); } catch (_) {}
      }
      // force re-render so counter updates immediately
      setSyncTick((t) => t + 1);
    } catch (_) { }
  };

  // Refresh user counts on page load
  useEffect(() => {
    syncUserFromServer();
  }, []);

  // Update counts when user returns to the tab/page
  useEffect(() => {
    const onFocus = () => { syncUserFromServer(); };
    const onVisibility = () => {
      if (document.visibilityState === 'visible') syncUserFromServer();
    };
    window.addEventListener('focus', onFocus);
    document.addEventListener('visibilitychange', onVisibility);
    return () => {
      window.removeEventListener('focus', onFocus);
      document.removeEventListener('visibilitychange', onVisibility);
    };
  }, []);


  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
  };
  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };
  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  const { searchQuery } = useSearch();

  // Show upgrade popup logic:
  // - Do NOT show while verifying payment (checkout=success present)
  // - Free users: show immediately
  // - Standard users: show only after 3 tests used
  // - PREMIUM/Admin: never show; PROFESSIONAL has 12 tests
  useEffect(() => {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const checkout = urlParams.get('checkout');
      if (checkout === 'success') return; // skip while verifying payment

      const userStr = localStorage.getItem('user');
      const user = userStr ? JSON.parse(userStr) : null;
      const userPlan = user?.plan || 'FREE';
      const isUnlimited = user && (userPlan === 'PREMIUM' || user.role === 'admin');
      const isStandard = userPlan === 'STANDARD';
      const isProfessional = userPlan === 'PROFESSIONAL';

      if (isUnlimited) return;
      if (isStandard) {
        const testsTaken = user?.testsTaken || 0;
        if (testsTaken >= 3) {
          setShowUpgradePopup(true);
        }
        return;
      }
      if (isProfessional) {
        const testsTaken = user?.testsTaken || 0;
        if (testsTaken >= 12) {
          setShowUpgradePopup(true);
        }
        return;
      }
      // Free user
      setShowUpgradePopup(true);
    } catch (_) { }
  }, []);

  const canTakeFreeTest = () => {
    try {
      const userStr = localStorage.getItem('user');
      const user = userStr ? JSON.parse(userStr) : null;
      const userPlan = user?.plan || 'FREE';
      const isUnlimited = user && (userPlan === 'PREMIUM' || user.role === 'admin');
      const isStandard = userPlan === 'STANDARD';
      const isProfessional = userPlan === 'PROFESSIONAL';

      if (isUnlimited) return true;
      if (isStandard) {
        // Standard users can take up to 3 tests
        // Use server data (user.testsTaken) as the source of truth
        const testsTaken = user.testsTaken || 0;
        return testsTaken < 3;
      }
      if (isProfessional) {
        const testsTaken = user.testsTaken || 0;
        return testsTaken < 12;
      }

      // Free users can take 1 test
      const used = localStorage.getItem('freeTestUsed');
      return used !== '1';
    } catch (_) { return false; }
  };

  const markFreeTestUsed = () => {
    try { localStorage.setItem('freeTestUsed', '1'); } catch (_) { }
  };


  const handleTakeTestClick = async (testTitle) => {
    // Ensure latest testsTaken from server before gating
    await syncUserFromServer();

    if (canTakeFreeTest()) {
      // For free users, mark test as used immediately
      try {
        const userStr = localStorage.getItem('user');
        const user = userStr ? JSON.parse(userStr) : null;
        const userPlan = user?.plan || 'FREE';
        const isStandard = userPlan === 'STANDARD';
        const isUnlimited = user && (userPlan === 'PREMIUM' || user.role === 'admin');

        // Only mark free test as used for non-premium users
        if (!isUnlimited && !isStandard) {
          markFreeTestUsed();
        }
      } catch (_) { }

      if 
      (testTitle === 'Essence Echo') {
        navigate('/sevenquestion');
      } 
      // else if (testTitle === 'IKIGAI Finder') {
      //   navigate('/ikigaiapp?test=ikigai');
      // } else if (testTitle === 'Johari Window Builder') {
      //   navigate('/ikigaiapp?test=johari');
      // } else if (testTitle === 'Big Five Personality Test') {
      //   navigate('/bigfivetest');
      // } else if (testTitle === 'Emotional IQ Test') {
      //   navigate('/emotionalintelligencetest');
      // } else if (testTitle === 'High 5 Strengths Test') {
      //   navigate('/highstrengthtest');
      // } else if (testTitle === 'VIA Character Strengths Survey') {
      //   navigate('/viacharacterstrengthtest');
      // } else if (testTitle === 'Competency Quiz') {
      //   navigate('/competencyquiz');
      // } else if (testTitle === 'Learning Style Assessment') {
      //   navigate('/learningstyleassessment');
      // } else if (testTitle === 'TypeFusion Finder 16 Types inspired by MBTI' || testTitle === 'Myers-Briggs Personality Tests' || testTitle === 'Myers-Briggs Personality Test') {
      //   navigate('/mbtitest');
      // } else if (testTitle === 'Enneagram Finder') {
      //   navigate('/enneagramtest');
      // } 
      // else if (testTitle === 'DISC Assessment') {
      //   navigate('/disctest');
      // }
    } else {
      setShowUpgradePopup(true);
    }
  };

  const startCheckout = async (plan) => {
    try {
      const successUrl = `${window.location.origin}/personality-test?checkout=success&plan=${encodeURIComponent(plan)}`;
      const cancelUrl = `${window.location.origin}/personality-test?checkout=cancelled&plan=${encodeURIComponent(plan)}`;
      const response = await api.post('/api/billing/create-checkout-session', {
        plan,
        successUrl,
        cancelUrl,
      });
      const { id, url } = response.data || {};
      const publishableKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
      if (id && publishableKey) {
        const stripe = await loadStripe(publishableKey);
        const { error } = await stripe.redirectToCheckout({ sessionId: id });
        if (error) {
          console.error('Stripe redirect error:', error);
          if (url) window.location.href = url;
        }
      } else if (url) {
        window.location.href = url;
      }
    } catch (error) {
      console.error('Checkout error', error);
      const serverMessage = error?.response?.data?.message;
      const serverError = error?.response?.data?.error;
      alert(serverMessage || serverError || 'Unable to start checkout right now. Please try again later.');
    }
  };

  // Check for successful payment and verify with server (with retries)
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const checkout = urlParams.get('checkout');
    const plan = urlParams.get('plan');

    if (checkout === 'success' && plan) {
      setIsVerifying(true);
      const verifyPayment = async () => {
        const maxAttempts = 6;
        const delayMs = 1500;
        for (let attempt = 1; attempt <= maxAttempts; attempt++) {
          try {
            const response = await api.get('/api/billing/verify-payment');
            const { role, plan, maxTests, testsTaken } = response.data || {};

            if (role === 'user' || role === 'admin') {
              const userStr = localStorage.getItem('user');
              if (userStr) {
                const user = JSON.parse(userStr);
                user.role = role;
                if (plan) user.plan = plan;
                user.maxTests = maxTests;
                user.testsTaken = testsTaken;
                localStorage.setItem('user', JSON.stringify(user));
                try { updateUser(user); } catch (_) {}
              }
              setShowUpgradePopup(false);
              try {
                const basePath = '/personality-test';
                window.history.replaceState(null, document.title, basePath);
              } catch (_) { }
              setIsVerifying(false);
              return;
            }
          } catch (error) {
            // continue retrying
          }
          await new Promise(r => setTimeout(r, delayMs));
        }
        setIsVerifying(false);
        console.error('Payment verification did not confirm upgrade in time');
      };

      verifyPayment();
      return;
    }

    // If cancelled, clean URL to avoid query-param loops
    if (checkout === 'cancelled') {
      try {
        const basePath = '/personality-test';
        window.history.replaceState(null, document.title, basePath);
      } catch (_) { }
    }
  }, []);

  const tests = useMemo(() => ([
    // {
    //   title: 'DISC Assessment',
    //   desc: 'Gain clarity on your personality and behavior style as well as others by measuring four traits: Dominance, Influence, Steadiness, and Conscientiousness.',
    //   icon: require('../assets/person frame 1.png'),
    //   bg: '#FFE5E1',
    //   frameColor: '#F9B6B0',
    //   badge: 'Career',
    //   badgeColor: '#F9B6B0',
    //   btnColor: '#F9B6B0',
    //   keywords: ['disc', 'behavior', 'behavioral', 'dominance', 'influence', 'steadiness', 'conscientiousness']
    // },
    {
      title: 'Essence Echo',
      desc: 'An honest introspection reflecting on your unique values, passions, and impact to reveal your authentic self and core essence. Start with what you know and we will handle the rest.',
      icon: require('../assets/person frame 2.png'),
      bg: '#F3E5F5',
      frameColor: '#B39DDB',
      badge: 'Career',
      badgeColor: '#CE93D8',
      btnColor: '#CE93D8',
      keywords: ['essence', 'echo', 'reflection']
    },
    // {
    //   title: 'Enneagram Finder',
    //   desc: 'Iden fy your core motivation, desires and fears among nine types of interconnected personalities. Explore deep-seated patterns that influence your life path, and see where they can lead',
    //   icon: require('../assets/person frame 3.png'),
    //   bg: '#E8F5E8',
    //   frameColor: '#A5D6A7',
    //   badge: 'Self',
    //   badgeColor: '#A5D6A7',
    //   btnColor: '#A5D6A7',
    //   keywords: ['enneagram']
    // },
    // {
    //   title: 'Big Five Personality Test',
    //   desc: 'Dive into the five broader dimensions that define your personality and influence your worldview. Measuring Openness, Conscien ousness, Extraversion, Agreeableness, and Neuro cism (OCEAN).',
    //   icon: require('../assets/person frame  4.png'),
    //   bg: '#E3F2FD',
    //   frameColor: '#90CAF9',
    //   badge: 'Self',
    //   badgeColor: '#90CAF9',
    //   btnColor: '#90CAF9',
    //   keywords: ['big five', 'ocean', 'openness', 'conscientiousness', 'extraversion', 'agreeableness', 'neuroticism']
    // },
    // {
    //   title: 'Emotional IQ Test',
    //   desc: 'Assess your emo onal intelligence to elevate self-awareness and connec on with others  Foster empathy and successful relationships by enhancing your emoional capabilities.',
    //   icon: require('../assets/person frame 5.png'),
    //   bg: '#FFF3E0',
    //   frameColor: '#FFD59A',
    //   badge: 'Career',
    //   badgeColor: '#FFD59A',
    //   btnColor: '#FFCC80',
    //   keywords: ['emotional intelligence', 'eq', 'emotional iq']
    // },
    // {
    //   title: 'Learning Style Assessment',
    //   desc: 'Discover your optimal learning method to enhance educational and professional growth. Tailor your development to your unique style for personal and professional growth at the highest level',
    //   icon: require('../assets/person frame 6.png'),
    //   bg: '#FCE4EC',
    //   frameColor: '#F8BBD9',
    //   badge: 'Self',
    //   badgeColor: '#F8BBD9',
    //   btnColor: '#F8BBD9',
    //   keywords: ['learning style', 'vark']
    // },
    // {
    //   title: 'VIA Character Strengths Survey',
    //   desc: 'Identify and rank the core 24 positive virtues that motivate your actions and decisions, creating a path for authentic living. Enhance personal growth and enrich interac ons with these insights.',
    //   icon: require('../assets/tree.png'),
    //   bg: '#E8F5E8',
    //   frameColor: '#A5D6A7',
    //   badge: 'Self',
    //   badgeColor: '#A5D6A7',
    //   btnColor: '#C5E1A5',
    //   keywords: ['via', 'character strengths']
    // },
    // {
    //   title: 'Competency Quiz',
    //   desc: 'Evaluate your key skills to understand how they align with your long-term aspira ons. Pinpoint development areas to strategically advance your life and career goals.',
    //   icon: require('../assets/person frame 8.png'),
    //   bg: '#F3E5F5',
    //   frameColor: '#B39DDB',
    //   badge: 'Career',
    //   badgeColor: '#B39DDB',
    //   btnColor: '#B39DDB',
    //   keywords: ['competency']
    // },
    // {
    //   title: 'High 5 Strengths Test',
    //   desc: 'Discover your top five strengths and natural talents by measuring your recurring thought patterns, mo va ons and behaviors. Embrace your innate strengths to transform your life starting now',
    //   icon: require('../assets/target.png'),
    //   bg: '#FFE5E1',
    //   frameColor: '#F9B6B0',
    //   badge: 'Self',
    //   badgeColor: '#F9B6B0',
    //   btnColor: '#FF9595',
    //   keywords: ['high5', 'high 5', 'strengths']
    // },
    // {
    //   title: 'TypeFusion Finder 16 Types inspired by MBTI',
    //   desc: 'Reveal your personality type out of the 16 types by using four different pairs of preferences to gain greater insight. This helps to showcase how they a4ect your decisions and interpersonal interactions.',
    //   icon: require('../assets/star frame.png'),
    //   bg: 'rgba(52,129,254,0.10)',
    //   frameColor: '#90CAF9',
    //   badge: 'Career',
    //   badgeColor: '#8AA9FF',
    //   btnColor: 'rgba(25,118,210,0.50)',
    //   keywords: ['mbti', '16 types', 'myers-briggs']
    // },
    // {
    //   title: 'IKIGAI Finder',
    //   desc: 'Explore what you love and where you excel to find intersectionality of your purpose and direction. Use this to align your life with deeper meaning and unlocking higher levels of fulfillment.',
    //   icon: require('../assets/bulb.png'),
    //   bg: '#FFF3E0',
    //   frameColor: '#FFD59A',
    //   badge: 'Career',
    //   badgeColor: '#FFA07F',
    //   btnColor: '#FFA07F',
    //   keywords: ['ikigai']
    // },
    // {
    //   title: 'Johari Window Builder',
    //   desc: 'Unpack open and hidden traits while discovering blind spots through valuable feedback, fostering self-awareness. Understand how you show up fully by seeing through the eyes of other.',
    //   icon: require('../assets/color palette.png'),
    //   bg: '#FCE4EC',
    //   frameColor: '#F8BBD9',
    //   badge: 'Self',
    //   badgeColor: '#FC95C0',
    //   btnColor: '#FC95C0',
    //   keywords: ['johari']
    // },
  ]), []);

  const filteredTests = useMemo(() => {
    const q = (searchQuery || '').trim().toLowerCase();
    if (!q) return tests;
    return tests.filter(t =>
      t.title.toLowerCase().includes(q) ||
      (t.desc && t.desc.toLowerCase().includes(q)) ||
      (t.keywords || []).some(k => k.includes(q))
    );
  }, [tests, searchQuery]);

  return (

    <div className="flex flex-col min-h-screen w-full overflow-x-hidden" style={{ background: 'linear-gradient(90deg, #FFFFFF 0%, #EFF6FF 100%, #F9FAFB 100%)' }}>
      <div className="fixed top-0 left-0 h-screen w-64 bg-white shadow-md z-10">
        <Sidebar isOpen={sidebarOpen} onClose={closeSidebar} />
      </div>
      <div className='ml-0 md:ml-64 flex-1 relative'>

        <Navbar toggleSidebar={toggleSidebar} />


        {/* Standard User Test Counter (hide during verification) */}
        {(() => {
          try {
            const userStr = localStorage.getItem('user');
            const user = userStr ? JSON.parse(userStr) : null;
            const userPlan = user?.plan || 'FREE';
            const isStandard = userPlan === 'STANDARD';

            if (isStandard && !isVerifying) {
              const testsTaken = user.testsTaken || 0;
              const testsLeft = 3 - testsTaken;

              return (
                <div style={{width:'95%'}} className={`mt-4 ml-4 p-4 border rounded-lg ${testsLeft > 0
                    ? 'bg-white border-blue-200'
                    : 'bg-white border-red-200'
                  }`}>
                  <p className={`text-center font-semibold ${testsLeft > 0 ? 'text-blue-800' : 'text-red-800'
                    }`}>
                    {testsLeft > 0
                      ? `Standard Plan: ${testsLeft} test${testsLeft !== 1 ? 's' : ''} remaining`
                      : 'Standard Plan: All tests used - Upgrade for more tests'
                    }
                  </p>
                </div>
              );
            }
            return null;
          } catch (_) {
            return null;
          }
        })()}
        <section className="w-full flex flex-col items-center justify-center mt-28 pb-10 bg-transparent px-4 sm:px-6 lg:px-8">
          <div className="w-full max-w-7xl mx-auto">
            <h2
              className="text-center mb-4 text-2xl sm:text-3xl md:text-4xl lg:text-5xl"
              style={{
                fontFamily: 'Roboto Slab, serif',
                fontWeight: 700,
                fontStyle: 'normal',
                lineHeight: '1.2',
                letterSpacing: '0%',
              }}
            >
              Personality Test
            </h2>
            <p className="text-gray-600 text-sm sm:text-base md:text-lg text-center max-w-4xl mx-auto">
              <span style={{ textAlign: 'center', display: 'block' }}>
                Discover the complete spectrum of human personality through our comprehensive 12-type system. Each type represents a unique combination of traits, strengths, and perspectives that shape how you interact with the world.
              </span>
            </p>


          </div>
        </section>


        <section className="w-full px-4 sm:px-6 lg:px-8 pb-12">
          <div className="w-full max-w-7xl mx-auto">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 sm:gap-6 lg:gap-8">
              {filteredTests.map((test, idx) => (
                <div
                  key={idx}
                  className={`rounded-xl shadow-lg p-4 sm:p-6 flex flex-col w-full min-h-[280px] sm:min-h-[320px] lg:min-h-[340px] items-start`}
                  style={{ background: test.bg }}
                >
                  {/* Icon - now left aligned */}
                  <div className="flex flex-col items-start justify-center mt-2 mb-2 w-full">
                    <div
                      className="flex items-center justify-center shadow-md"
                      style={{
                        background: test.frameColor,
                        width: '48px',
                        height: '40px',
                        borderRadius: '12px',
                        opacity: 1
                      }}
                    >
                      <img
                        src={test.icon}
                        alt=""
                        style={{
                          width: '20px',
                          height: '20px',
                          opacity: 1,
                          filter: test.title === 'The 7 questions of understanding' ? 'brightness(1.2) contrast(1.1)' : 'none'
                        }}
                        className="sm:w-6 sm:h-6"
                      />
                    </div>
                    <h3
                      className="font-bold text-base sm:text-lg mt-3 mb-1 w-full"
                      style={{ fontFamily: 'Roboto Slab, serif', textAlign: 'left' }}
                    >
                      {test.title}
                    </h3>
                  </div>

                  <div
                    className="flex items-center gap-2 mb-2 justify-start w-full"
                  >
                    <span className="text-xs font-semibold px-2 py-1 rounded" style={{ background: test.badgeColor, color: '#fff', fontFamily: 'Roboto Slab, serif', textAlign: 'left' }}>{test.badge}</span>
                    <span className="text-gray-400 text-xs flex items-center" style={{ fontFamily: 'Roboto Slab, serif', textAlign: 'left' }}>
                      <svg className="w-3 h-3 sm:w-4 sm:h-4 mr-1 inline" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4l3 3"></path>
                        <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" fill="none"></circle>
                      </svg>
                      8-10 mins
                    </span>
                  </div>

                  <p className="text-gray-500 text-xs ss:text-ss flex-1 w-full" style={{ fontFamily: 'Roboto Slab, serif', textAlign: 'left' }}>{test.desc}</p>

                  <button
                    className="mt-4 w-full py-2 rounded-lg font-bold shadow-md transition-colors hover:brightness-90 text-sm sm:text-base"
                    style={{ background: test.btnColor, color: '#fff', boxShadow: '0 4px 16px 0 rgba(0,0,0,0.15)', fontFamily: 'Roboto Slab, serif' }}
                    onClick={() => handleTakeTestClick(test.title)}
                  >
                    Take a Test
                  </button>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section
          className="w-full flex items-center justify-center py-8 sm:py-12 lg:py-16 px-4 sm:px-6 lg:px-8"
          style={{
            background: 'linear-gradient(90deg, #8f44fd 0%, #e94b8b 100%)',
            minHeight: '434.03px'
          }}
        >
          <div className="w-full max-w-7xl mx-auto flex flex-col items-center justify-center text-center">
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-extrabold text-white text-center mb-4" style={{ fontFamily: 'Roboto Slab, serif' }}>Ready to Discover Your True Self?</h2>
            <p className="text-white text-sm sm:text-base md:text-lg text-center mb-6 sm:mb-8 max-w-2xl mx-auto">Join over 2 million people who have unlocked their potential with our personality assessment.</p>
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center items-center w-full max-w-md sm:max-w-lg mx-auto">
              <button
                className="w-full sm:w-auto px-6 py-2 sm:py-3 bg-white text-[#9C27B0] rounded font-semibold shadow hover:bg-gray-100 transition text-sm sm:text-base border border-white"
              >
                Start Your Journey Today
              </button>
              <button
                className="w-full sm:w-auto px-6 py-2 sm:py-3 bg-transparent border border-white text-white rounded font-semibold shadow transition text-sm sm:text-base"
              >
                Explore Personality Types
              </button>
            </div>
          </div>
        </section>
      </div>


      {showUpgradePopup && (
        <div
          className="fixed inset-0 z-[3000] flex items-center justify-center bg-black bg-opacity-40"
          onClick={() => setShowUpgradePopup(false)}
        >
          <div
            className="bg-white w-[95%] max-w-4xl rounded-xl overflow-hidden shadow-lg"
            style={{ position: 'absolute', top: '10px', overflow: 'auto', height: '96vh' }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="bg-gradient-to-r from-purple-500 to-pink-500 text-white text-center py-6 px-4">
              <img onClick={() => setShowUpgradePopup(false)} src={closer} alt="close" style={{ width: '20px', margin: '6px auto', position: 'absolute', right: '20px', cursor: 'pointer' }} />
              <img src={updated} alt="updated" style={{ width: '56px', margin: '6px auto' }} />
              <h2 className="text-xl font-bold">Limited Time Offer - 50% Off!</h2>
              <p className="text-sm mt-1">Special discount expires in 24 hours - Don't miss out!</p>
            </div>
            {canTakeFreeTest() && (
              <div className='border rounded-lg w-[90%] p-5 text-center mx-auto mt-4'>
                <div className="flex justify-center py-4 items-center gap-2">
                  <img src={free} alt="free" style={{ width: '60px' }} />
                  <p>Free</p>
                </div>
                <div className="flex justify-center py-4 items-center gap-5">
                  <p>✔ Simple Tests</p>
                  <p>✔ Quick Insights</p>
                  <p>✔ No Feedback</p>
                  <p>✔ You can try it only once</p>
                </div>
                <button
                  className="bg-[#000] text-white p-2 px-5 rounded"
                  onClick={() => {
                    setShowUpgradePopup(false);
                    // Allow user to take one free test
                  }}
                >
                  Get Started
                </button>
              </div>
            )}

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 px-6 pb-6 mt-8">
              {/* Free Plan */}
              <div className="border rounded-lg w-full p-5 text-center">
                <img src={Standard} alt="free" style={{ width: '56px', margin: '6px auto' }} />
                <h2 className="text-2xl font-bold mb-2">Standard</h2>
                <div className="text-2xl font-bold mb-2">15$</div>
                <ul className="text-sm text-gray-600 text-left mb-4 space-y-2">
                  <li>✔ (3) tests of your choice</li>
                  <li>✔ Dashboard, full reports</li>
                  <li>✔ Limited analytics</li>
                </ul>
                <button
                  onClick={() => startCheckout('standard')}
                  className="bg-[#FFCC80] text-black w-full py-2 rounded hover:bg-[#FFB74D] transition-colors"
                >
                  Get Started
                </button>
              </div>

              {/* Premium Plan */}
              <div className="relative border-2 border-blue-500 rounded-lg w-full p-5 text-center">
                <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-blue-500 text-white text-xs px-3 py-1 rounded">Most Popular</span>
                <img src={Premium} alt="Premium" style={{ width: '56px', margin: '6px auto' }} />
                <h2 className="text-2xl font-bold mb-2">All Access Professional</h2>
                <p>Complete personality analysis</p>
                <div className="font-bold text-xl mb-2">$144.99/year</div>
                <div className="text-green-600 text-xl mb-2">$12/Tests</div>
                <ul className="text-sm text-gray-600 text-left mb-4 space-y-2">
                  <li>✔ (12) Tests</li>
                  <li>✔ Pay once</li>
                  <li>✔ lifetime access to everything and full reports</li>
                  <li>✔ Each test is $12/per (Most Popular)</li>
                  <li>✔ Personal growth recommendations</li>
                </ul>
                <button onClick={() => startCheckout('professional')} className="bg-blue-600 text-white w-full py-2 rounded">Get Started</button>
              </div>

              <div className="border rounded-lg w-full p-5 text-center">
                <div>
                  <img src={premiumCrown} alt="Professional" style={{ width: '56px', margin: '6px auto' }} />
                </div>
                <h2 className="text-2xl font-bold mb-2">Premium</h2>
                <p>personality insights</p>
                <div className="font-bold text-xl mb-2">$199.99/year</div>
                <ul className="text-sm text-gray-600 text-left mb-4 space-y-2">
                  <li>✔ Everything in all-access</li>
                  <li>✔ + 1 hr consult w/coach</li>
                  <li>✔ Personalized take home purpose plan & free PPP ebook. (Best Value)</li>
                  <li>✔ Personalized personal plan</li>
                </ul>
                <button onClick={() => startCheckout('premium')} className="bg-[#AC2FC2] text-white w-full py-2 rounded">Get Started</button>
              </div>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default PersonalityTest; 